import { Component, OnInit,Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { IMyDateRangeModel, IMyDrpOptions } from 'mydaterangepicker';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-call-logs-filter-modal',
  templateUrl: './call-logs-filter-modal.component.html',
  styleUrls: ['./call-logs-filter-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CallLogsFilterModalComponent implements OnInit {
  myDateRangePickerOptions = {     
    dateFormat: 'dd.mm.yyyy'      
};
callLogFilterForm:FormGroup;


dropdownList = [];
selectedItems = [];
dropdownSettings = {};
dropdownSettingsUsers={};

  constructor(
    private dialogRef:MatDialogRef<CallLogsFilterModalComponent>,
    private serverService:ServerService,
    private clipBoardService:ClipBoardService,
    private fb:FormBuilder,
    @Inject(MAT_DIALOG_DATA) private data
  ) { 
    this.callLogFilterForm = this.fb.group({
      user: [''],
      project: [''],
      createdAt:['']

  })
      if (data.project != undefined) {
        this.selectedProject = data.project
      }
      if (data.user != undefined) {
        this.selectedUser = data.user
      }
      if (data.createdAt != undefined) {
        this.createdAt = data.createdAt
      }
  }
  authToken = localStorage.getItem('token');
  projects:any;
  users:any;
  project_list:string[];
  user_list:string[];
  createdAt:any;
  selectedProject: any = ''
  selectedUser: any = ''
  showComponentLoader = false;
  searchProject:any;
  filteredProject:any;
  noOfProjects:any;
  searchUser:any;
  noOfUsers:any;
  ngOnInit() {
    this.showComponentLoader = false;
    this.createdAt = '';
    this.selectedProject = []
    this.selectedUser = [];

    this.getProjectList();
    this.getUserList();
    
    // console.log(this.data.project.id);


    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'project_client',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll:false
    };
    this.dropdownSettingsUsers = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll:false
    };

  }
  getProjectList(){
    let body = {
      "search": "",
      "module_type": "projects"
    }
    this.serverService.getProjectBySearch(body,this.authToken).subscribe((data)=>{
      // console.log()
      this.noOfProjects = data.length;
      this.projects = data.projects;
      this.showComponentLoader = true;
    },
    err => {
      this.showComponentLoader = false
      this.clipBoardService.checkServerError(err, this.authToken)
        }
    )
  }
  getUserList(){
    let body = {
      "search": "",
      "module_type": "users"
    }
    this.serverService.getUserBySearch(body,this.authToken).subscribe((data)=>{
      this.users = data.users
      this.showComponentLoader = true;
    },
    err => {
      this.showComponentLoader = true
      this.clipBoardService.checkServerError(err, this.authToken)
        })
  }
  filter(){
    // debugger
    let selectedArr = []
    let selectedUs = [];
    for(let item of this.selectedProject){
      selectedArr.push(item)
    }
    for(let item of this.selectedUser){
      selectedUs.push(item)
    }
    this.selectedUser = selectedUs;
    this.selectedProject = selectedArr;
    let body = {}
        if (this.selectedProject != undefined && this.selectedProject != "") {
            body["selectedProject"] = this.selectedProject
        }
        
        if (this.selectedUser != undefined && this.selectedUser != "") {
          body["selectedUser"] = this.selectedUser
      }
        if (this.createdAt != undefined && this.createdAt != "") {
            body["createdAt"] = this.createdAt
        }

        // console.log(body)
        this.dialogRef.close(body)
  }
  
  close(){
    this.dialogRef.close()
  }
  clear(){
    this.project_list = [];
    this.user_list = [];
    this.createdAt = '';
    // this.searchProject = '';
    // this.searchUser = '';
    this.selectedProject = []
    this.selectedUser = [];
    // this.projects = [];
    // this.users = [];
  }
}
